import { type IAdvertise } from "../../../../store/slices/advertisesSlice";

export const filterAndSortAdds = (unit: any, task : IAdvertise,  sortType :Record<string, any>): boolean => {
    console.log({unit, task ,  sortType})
    const sortByAddGroups = sortType.byAddsGroups as string[]
    const sortByTypeUnit = sortType.sortByTypeUnit
    const statuses = task?.attributes?.Statuses as any[]; 
    const sortByUnitID = sortType.unitID
     
    const statusMatch = sortByAddGroups?.includes('all') || sortByAddGroups?.includes(statuses[0])
    const idMatch = !sortByUnitID || Number(sortByUnitID) === Number(unit?.id);
      
       
    if (!statusMatch) return false;
    if (!idMatch) return false;
      
    if (sortByTypeUnit === 'all') return true;
    if (sortByTypeUnit === 'sale') return unit?.attributes?.Marketing?.Use === 'For sale';
    if (sortByTypeUnit === 'rent') return unit?.attributes?.Marketing?.Use === 'For rent';
    return false;
};